<template>
  <div>
    <div>
      <p class="sheet-title">{{ $t('purchasing_notice_title') }}</p>
      <content-show-more v-model="shouldAllShow" :hide="!shouldMoreInfoButtonShow" class-name="mt-4 mb-0">
        <div
          id="productShoppingNotice__sheetContent"
          ref="shoppingNoticeRef"
          class="sheet-content"
          :class="shouldAllShow ? 'wd-line-clamp-none' : 'wd-line-clamp-10'"
        >
          <!-- Must have div below to prevent content overlap -->
          <div>
            <product-content-list :nodes="shoppingNotices" />
          </div>
        </div>
      </content-show-more>
    </div>
  </div>
</template>

<script>
import ContentShowMore from '@/components/ContentShowMore.vue'
import ProductContentList from '@/components/page/products/ProductContentList.vue'

export default defineComponent({
  name: 'ProductShoppingNotice',
  components: {
    ContentShowMore,
    ProductContentList,
  },
  props: {
    shoppingNotices: { type: Array, default: () => [] },
  },
  data() {
    return {
      shouldAllShow: false,
      shouldMoreInfoButtonShow: false,
    }
  },
  mounted() {
    this.setShouldMoreInfoButtonShow()
  },
  methods: {
    setShouldMoreInfoButtonShow() {
      // 220px is 22(line-height) x 10(lines). But it will be 218px in Safari, set it to 200(> 22 x 9).
      this.shouldMoreInfoButtonShow = this.$refs.shoppingNoticeRef?.getBoundingClientRect().height >= 200
    },
  },
})
</script>

<style lang="scss" scoped>
.sheet-content {
  overflow: hidden;
  text-overflow: ellipsis;
  :deep(strong) {
    line-height: 1em;
  }
  :deep(p) {
    margin-bottom: 0px;
  }
  :deep(*) {
    line-height: 22px;
  }

  @include xxs {
    &#productShoppingNotice__sheetContent {
      margin-bottom: 6px;
    }
  }
}
</style>
